<template>
  <div class="outverify-index">
    <div class="title">
      <span>支出审核列表</span>
      <!-- <mu-button class="add-btn" color="purple" @click="addOpen = true">
        <mu-icon value="add" :size="20"></mu-icon>
        新增支出审核
      </mu-button> -->
    </div>
    <mu-form :model="form" label-width="80" class="form" :inline="true">
      <mu-form-item prop="search" label="搜索" label-position="left">
        <mu-text-field
          v-model="form.keyword"
          help-text="请输入搜索内容"
        ></mu-text-field>
      </mu-form-item>
      <mu-form-item>
        <mu-button color="primary" @click="getAll">
          <mu-icon left value="search" :size="20"></mu-icon>
          搜索
        </mu-button>
      </mu-form-item>
    </mu-form>
    <mu-paper :z-depth="1">
      <mu-data-table
        :columns="columns"
        :data="list"
        stripe
        class="table"
        :loading="loading"
      >
        <template slot-scope="scope">
          <td>
            <mu-button color="success" @click="ViewDetail(scope.row.out)">
              <mu-icon left value="list" :size="20"></mu-icon>
              查看
            </mu-button>
          </td>
          <td>{{ scope.row.verifier.realName }}</td>
          <td>
            {{
              scope.row.isVerified === null
                ? '未审核'
                : scope.row.isVerified
                ? '已审核通过'
                : '审核不通过'
            }}
          </td>
          <td>
            {{
              scope.row.verifyTime
                ? moment(scope.row.verifyTime).format('YYYY-MM-DD HH:mm')
                : ''
            }}
          </td>
          <td>{{ scope.row.remark }}</td>
          <!-- <td>
            <mu-button color="info" @click="edit(scope.row)">
              <mu-icon left value="edit" :size="20"></mu-icon>
              编辑
            </mu-button>
            <mu-button color="secondary" @click="deleteOne(scope.row)">
              <mu-icon left value="delete" :size="20"></mu-icon>
              删除
            </mu-button>
          </td> -->
        </template>
      </mu-data-table>
    </mu-paper>
    <div class="page">
      <div class="info">共{{ total }}条记录</div>
      <mu-pagination
        raised
        :total="total"
        :current.sync="form.page"
        :page-size="15"
        @change="getAll"
      ></mu-pagination>
    </div>
    <Create :open.sync="addOpen" @finish="getAll()"></Create>
    <Update :open.sync="editOpen" :form="editForm" @finish="getAll()"></Update>
    <Detail :open.sync="detailOpen" :detail="detail"></Detail>
  </div>
</template>

<script>
import Create from './create'
import Update from './update'
import Detail from './detail'
import backend from 'utils/backend'
import api from '@/api'
import moment from 'moment'
export default {
  components: { Create, Update, Detail },
  data() {
    return {
      loading: false,
      addOpen: false,
      editOpen: false,
      detailOpen: false,
      detail: {
        user: {},
        images: []
      },
      editForm: {},
      form: {
        keyword: '',
        page: 1,
        relations: ['outVerify.verifier', 'outVerify.out', 'out.user']
      },
      total: 1,
      columns: [
        {
          title: '支出详情',
          name: 'out',
          align: 'center'
        },
        {
          title: '审核人',
          name: 'verify',
          align: 'center'
        },
        {
          title: '是否通过',
          name: 'isVerified',
          align: 'center'
        },
        {
          title: '审核时间',
          name: 'verifyTime',
          align: 'center'
        },
        {
          title: '备注',
          name: 'remark',
          align: 'center'
        }
        // {
        //   title: '操作',
        //   align: 'center',
        //   width: 400
        // }
      ],
      list: [],
      moment
    }
  },
  methods: {
    edit(item) {
      this.editForm = item
      this.editOpen = true
    },
    deleteOne(item) {
      this.$confirm('确定要删除？', '提示', {
        type: 'warning'
      }).then(({ result }) => {
        if (result) {
          backend(api.outverify.delete, { id: item.id }).then((result) => {
            if (result.statusCode === 200) {
              this.$toast.success('删除成功')
              this.getAll()
            }
          })
        }
      })
    },
    getAll() {
      this.loading = true
      backend(api.outverify.getAll, this.form).then((result) => {
        if (result.statusCode === 200) {
          this.loading = false
          this.list = result.data.rows
          this.total = result.data.count
        }
      })
    },
    ViewDetail(out) {
      this.detail = out
      this.detailOpen = true
    }
  },
  mounted() {
    this.getAll()
  }
}
</script>

<style lang="less" scoped>
.outverify-index {
  position: relative;
  .title {
    font-size: 20px;
    margin-bottom: 10px;
    line-height: 36px;
    .add-btn {
      margin-left: 20px;
    }
  }
  .table {
    td {
      text-align: center;
    }
  }
  .page {
    position: absolute;
    right: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    .info {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/outVerify/index.vue